//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Horizontal from "@/components/horizontal.comp.vue";
export default {
  name: 'Genres',
  computed: {
    ...mapGetters(["allGenres", "genresTvShows"])
  },
  components: {
    Horizontal
  }
}
